import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { catchError, throwError } from 'rxjs';
import { AdminAuthService } from '../auth/admin-auth.service';
import { isAdminApiRequest } from '../auth/admin-api-target';
import { environment } from '../../../environments/environment';

export const adminAuthInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AdminAuthService);
  const document = inject(DOCUMENT);
  const isAdminApi = isAdminApiRequest(req.url, environment.adminApiUrl, document.baseURI);
  const token = isAdminApi ? authService.getToken() : null;
  if (token) {
    req = req.clone({ setHeaders: { Authorization: `Bearer ${token}` } });
  }
  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      // Third-party errors must neither receive an admin token nor log out OPS.
      if (isAdminApi && error.status === 401) authService.logout();
      return throwError(() => error);
    })
  );
};
